import { render } from "./EventBanner.vue?vue&type=template&id=a8783894&scoped=true"
import script from "./EventBanner.vue?vue&type=script&lang=js"
export * from "./EventBanner.vue?vue&type=script&lang=js"

import "./EventBanner.vue?vue&type=style&index=0&id=a8783894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8783894"]])

export default __exports__